import * as com from "./tmpls";
import { DEXTokenTierView } from "../api/classes/models";
import { App } from "../App";
import { EventGS, EventGSToken, WrapperGS } from "@ivanlog/gs";
import { CmpWidgetChart } from "./CmpWidgetChart";
import { LPXInfrastructure } from "../contracts/LPXInfrastructure";
import { LPXConfig, LPXConfigPack } from "../contracts/LPXContract";
import { PulseChain } from "../contracts/PulseChain";
import { BiMath } from "../libs/BiMath";

export class CmpWgtLPXNew extends com.CmpWgtLPXNewBase {
    private static readonly DUAL_NTZ_MIN_TEXT = "0.20";

    private _onClose:EventGS;
    private _onCloseToken:EventGSToken;
    private _selectedFund:DEXTokenTierView|undefined;
    private _selectedAnchor:DEXTokenTierView|undefined;

    private _tgls:WrapperGS[];

    public get onClose():EventGS {return this._onClose;}

    constructor() {
        super();
        //this.hide();
        this._onCloseToken = new EventGSToken();
        this._onClose = new EventGS(this._onCloseToken);

        const ctrl = this.ctrls;
        this._tgls=[ctrl.tglSelectFund,ctrl.tglSelectAnchor,ctrl.tglConfig];
        ctrl.btnSubmitFund.disable();
        ctrl.btnSubmitAnchor.disable();
        //ctrl.btnCreate.disable();

        ctrl.cmpSelectFund.onChangeValue.addHandler(token=>{
            this._selectedFund = token;
            ctrl.btnSubmitFund.enableSet(token != undefined);
        });
        ctrl.cmpSelectAnchor.onChangeValue.addHandler(token=>{
            this._selectedAnchor = token;
            ctrl.btnSubmitAnchor.enableSet(token != undefined);
            if (this._selectedAnchor?.address==this._selectedFund?.address) ctrl.btnSubmitAnchor.disable();
            ctrl.tglConfig.hide();
        });

        ctrl.btnSubmitFund.onclick=()=>{
            if (!this._selectedFund) { App.gui.dialogOkShowAsync("Select fund token"); return; }
            this._showStep("anchor");
        };
        ctrl.btnSubmitAnchor.onclick=()=>{
            if (!this._selectedAnchor) { App.gui.dialogOkShowAsync("Select anchor token"); return; }
            this._showStep("config");
        };
        ctrl.btnToFund.onclick=()=>{this._showStep("fund");}
        ctrl.btnToAnchor.onclick=()=>{this._showStep("anchor");}
        ctrl.btnCancel.onclick=()=>{
            this._close();
        }
        ctrl.btnCreate.onclick=async ()=>{  await App.gui.awaitInLockUIAsync(this._tryCreateAsync());}

        ctrl.cmpNtz.ctrls.iValue.el.addEventListener("change",()=>{ this._refreshInfo(); });
        ctrl.cmpNtz.ctrls.iValue.el.addEventListener("input",()=>{ this._refreshInfo(); });
        ctrl.cmpNtz.ctrls.iValue.el.addEventListener("blur",()=>{
            const ntzIndex = this._getIndex17BFromPercent(ctrl.cmpNtz.ctrls.iValue.value);
            if (ntzIndex !== undefined && ntzIndex < LPXInfrastructure.DUAL_NTZ_MIN_INDEX)
                ctrl.cmpNtz.ctrls.iValue.value = CmpWgtLPXNew.DUAL_NTZ_MIN_TEXT;
            this._refreshInfo();
        });
        ctrl.cmpProfit.onChangeValue.addHandler(()=>{this._refreshInfo();});
        this.resetAsync();
    }

    public async resetAsync()
    {
        const ctrl = this.ctrls;
        this._selectedFund = undefined;
        this._selectedAnchor = undefined;
        ctrl.btnSubmitFund.disable();
        ctrl.btnSubmitAnchor.disable();
        //ctrl.btnCreate.disable();
        this._resetTokenSelector(ctrl.cmpSelectFund);
        this._resetTokenSelector(ctrl.cmpSelectAnchor);
        ctrl.cmpProfit.value=0;
        ctrl.cmpNtz.ctrls.iValue.value="2.34";
        this._showStep("fund");
    }

    private _showStep(step:"fund"|"anchor"|"config")
    {
        const ctrl = this.ctrls;
        this._tgls.forEach(t=>{t.hide(); t.inactive();});
        if (step=="fund") {ctrl.tglSelectFund.active(); ctrl.tglSelectFund.show();}
        else if (step=="anchor") {ctrl.tglSelectAnchor.active(); ctrl.tglSelectAnchor.show();}
        else if (step=="config") {
            const fund = this._selectedFund;
            const anchor = this._selectedAnchor;
            ctrl.tglConfig.active(); 
            ctrl.tglConfig.show();
            ctrl.cmpNtz.ctrls.iValue.el.focus();
            if (fund&&anchor) 
            {
                ctrl.cmpChart.loadPairAsync(fund.address, anchor.address);
            }
            this._refreshInfo();
        }
    }

    private _resetTokenSelector(cmp:com.CmpSelectERC20Base)
    {
        cmp.ctrls.cmpSearch.ctrls.iSearch.value = "";
        cmp.ctrls.cmpSearch.ctrls.iSearch.el.dispatchEvent(new Event("input"));
    }


    private async _tryCreateAsync()
    {
        const account = App.chain.account;   

        const ntzIndex = this._getIndex17BFromPercent(this.ctrls.cmpNtz.ctrls.iValue.value);
        const harvest = BigInt(this.ctrls.cmpProfit.value);

        if (!account){ return; }
        if (!this._selectedFund){ App.gui.dialogOkShowAsync("Unknown fund token"); return; }
        if (!this._selectedAnchor){ App.gui.dialogOkShowAsync("Unknown anchor token"); return; }
        const fundAdr = this._selectedFund.address;
        const anchorAdr = this._selectedAnchor.address;
        if (ntzIndex==undefined){ App.gui.dialogOkShowAsync("Need to set NTZ"); return; }
        if (fundAdr.toLocaleLowerCase()==anchorAdr.toLocaleLowerCase()) { App.gui.dialogOkShowAsync("Fund is the same as anchor"); return; }

        const lpxInf = App.Inst.getInst(LPXInfrastructure);
        if (!lpxInf) return;

        if (ntzIndex<LPXInfrastructure.DUAL_NTZ_MIN_INDEX) { App.gui.dialogOkShowAsync(`NTZ must be at least ${CmpWgtLPXNew.DUAL_NTZ_MIN_TEXT}%`); return; }
        const feeIndex = this._getFeeIndex(ntzIndex);
        const profitBaseIndex = ntzIndex-feeIndex*2n;
        if (profitBaseIndex<0n) { App.gui.dialogOkShowAsync(`NTZ must be at least ${CmpWgtLPXNew.DUAL_NTZ_MIN_TEXT}%`); return; }

        const configPack = new LPXConfigPack()
        configPack.feeIndex = feeIndex;
        configPack.managerRewardIndex = 0n;
        configPack.ntzIndex = ntzIndex;
        configPack.profitIndex = profitBaseIndex*harvest/100n;
        configPack.poolType = BigInt(LPXInfrastructure.POOLTYPE_DUAL);
        let lpxPack = await lpxInf.lpxCtrlPools.getPackConfigPackAsync(0n,configPack);
        if (!lpxPack) { App.gui.dialogOkShowAsync("Can't create config"); return; }
        lpxPack = lpxInf.setFlag(lpxPack,LPXInfrastructure.PACKFLAG_MANAGER_ONLY);

        const configLPX = new LPXConfig();
        configLPX.manager = account;
        configLPX.fundToken = lpxInf.adrToPAdr(fundAdr);
        configLPX.anchorToken = lpxInf.adrToPAdr(anchorAdr);
        configLPX.pack = lpxPack;
        configLPX.totalShares = 0n;
        
        const tx = await lpxInf.lpxCtrlPools.poolCreateAsync(configLPX, 0n, "0");
        if (tx) {this._informTxSuccessful(); this._close();}
        lpxInf.refreshAsync();
    }

    private _close()
    {
        this._onCloseToken.invoke();
    }

    private _refreshInfo()
    {
        if (!this._selectedFund||!this._selectedAnchor) return;
        let ntz = this.ctrls.cmpNtz.ctrls.iValue.value;
        if (!ntz) ntz='0';
        const feeIndex = this._getFeeIndex(this._getIndex17BFromPercent(ntz)??0n);
        const feeText = `${feeIndex/1000n}.${(feeIndex%1000n).toString().padStart(3, "0")}`.replace(/\.?0+$/, "");

        const fundSymbol = PulseChain.GetSymbolOrDef(this._selectedFund.address, this._selectedFund.symbol);
        const anchorSymbol = PulseChain.GetSymbolOrDef(this._selectedAnchor.address, this._selectedAnchor.symbol);

        let harv = this.ctrls.cmpProfit.value;
        let comp = 100-harv;
        let text = `Fund: ${fundSymbol} (${this._selectedFund?.address})\n`;
        text    += `Anchor: ${anchorSymbol} (${this._selectedAnchor?.address})\n`;
        text    += `NTZ: ${ntz}%\n`;
        text    += `Harvest: ${harv}%\n`;
        text    += `Compound: ${comp}%\n`;
        text    += `Fee: ${feeText}\n`;
        this.ctrls.lInfo.text=text;


        const sellPrice = this.ctrls.cmpChart.lastClosePrice;
        if (sellPrice)
        {
            const buyPrice = sellPrice*(100-parseFloat(ntz))/100;
            this.ctrls.cmpChart.setLinePrice(CmpWidgetChart.LINE_SELL, sellPrice);
            this.ctrls.cmpChart.setLinePrice(CmpWidgetChart.LINE_BUY, buyPrice);
        }
    }

    private _getIndex17BFromPercent(value:string)
    {
        value = value.trim();
        if (!value) return undefined;
        if (value.charAt(0)==".") value = "0"+value;
        if (!/^[0-9]+(\.[0-9]{0,3})?$/.test(value)) return undefined;

        const parts = value.split(".");
        const integerPart = BigInt(parts[0]);
        const decimalPart = BigInt((parts[1]??"").padEnd(3, "0").slice(0, 3));
        return integerPart*1000n+decimalPart;
    }

    private _getFeeIndex(ntzIndex:bigint)
    {
        let feeIndex = ntzIndex*LPXInfrastructure.DUAL_FEE_FROM_NTZ_INDEX/BiMath.Decimal17B;
        if (feeIndex<LPXInfrastructure.DUAL_FEE_MIN_INDEX) feeIndex=LPXInfrastructure.DUAL_FEE_MIN_INDEX;
        return feeIndex;
    }

    private _informTxSuccessful() { App.gui.dialogOkShowAsync("✅Transaction successful!","") }
}
